import React, { useState, useEffect, useRef, useContext } from "react";
import axios from "axios";
import { FaBookOpen } from "react-icons/fa";
import { Play, Pause, Volume2, VolumeX, Loader2, VideoOff } from "lucide-react";
import AppContext from "../../../../context/AppContext";
// import "../../../../src/assets/css/screens/customer/about us/About.css"; // CSS path adjust karein

 // 🔸 apna real file base url yahan set kar lena

const Storysection = () => {
  const { baseUrl, baseUrlForFile } = useContext(AppContext);
  const [isVisible, setIsVisible] = useState(false);

  // ── Admin video states ──
  const [videoUrl, setVideoUrl] = useState(null);
  const [videoLoading, setVideoLoading] = useState(true);
  const [videoError, setVideoError] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const [isMuted, setIsMuted] = useState(true);

  const videoRef = useRef(null);

  useEffect(() => {
    // Animation trigger
    const timer = setTimeout(() => setIsVisible(true), 100);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const fetchVideo = async () => {
        try {
            setVideoLoading(true);
            setVideoError(false);

            const res = await axios.get(
                `${baseUrl}/landingpage/about-video`
            );

            if (res.data?.success && res.data?.video) {
                setVideoUrl(res.data.video);
            } else {
                setVideoError(true);
            }

        } catch (error) {
            console.log(error.response?.data || error.message);
            setVideoError(true);
        } finally {
            setVideoLoading(false);
        }
    };

    fetchVideo();
}, []);

  const togglePlay = () => {
    if (!videoRef.current) return;
    if (isPlaying) {
      videoRef.current.pause();
    } else {
      videoRef.current.play();
    }
    setIsPlaying(!isPlaying);
  };

  const toggleMute = () => {
    if (!videoRef.current) return;
    videoRef.current.muted = !isMuted;
    setIsMuted(!isMuted);
  };

  return (
    <section className="about-story-section">
      <div className="about-story-container">
        <div className="about-story-grid">
          {/* Story Content */}
          <div className={`about-story-content ${isVisible ? 'about-slide-left' : ''}`}>
            <div className="about-section-badge">
              <span className="about-badge-text"><FaBookOpen/>  OUR STORY</span>
            </div>

            <h2 className="about-section-title">
              Making Services Simple, Trusted & Accessible
            </h2>

            <p className="about-story-text">
              Picks4Tips was built around one core idea: bringing communities
              closer together by making it simple to find and connect with the
              right people. We believe every neighborhood has skilled, reliable
              professionals — our job is to help you find them.
            </p>

            <p className="about-story-text">
              Our platform creates a community-driven space where service seekers
              and responders come together, support one another, and build lasting
              trust — making it easier to post jobs, connect locally, and get
              things done with confidence.
            </p>

            <div className="about-story-features">
              <div className="about-story-feature">
                <span className="about-feature-check">✓</span>
                <span>Community-Verified Professionals</span>
              </div>

              <div className="about-story-feature">
                <span className="about-feature-check">✓</span>
                <span>Trusted Local Experience</span>
              </div>

              <div className="about-story-feature">
                <span className="about-feature-check">✓</span>
                <span>Reliable Community Support</span>
              </div>
            </div>
          </div>

          {/* Story Video (admin uploaded) */}
          <div className={`about-story-image ${isVisible ? 'about-slide-right' : ''}`}>
            {videoLoading ? (
              <div className="about-story-video-state">
                <Loader2 size={28} className="about-story-video-spin" />
                <p>Loading video...</p>
              </div>
            ) : videoError || !videoUrl ? (
              <div className="about-story-video-state">
                <VideoOff size={28} />
                <p>No video has been added yet.</p>
              </div>
            ) : (
              <div className="about-story-video-wrap">
                <video
                  ref={videoRef}
                  src={videoUrl}
                  className="about-story-video"
                  muted={isMuted}
                  playsInline
                  onClick={togglePlay}
                  onEnded={() => setIsPlaying(false)}
                />

                {!isPlaying && (
                  <button className="about-story-video__play-overlay" onClick={togglePlay}>
                    <Play size={30} fill="#fff" />
                  </button>
                )}

                <div className="about-story-video__controls">
                  <button className="about-story-video__ctrl-btn" onClick={togglePlay}>
                    {isPlaying ? <Pause size={15} /> : <Play size={15} />}
                  </button>
                  <button className="about-story-video__ctrl-btn" onClick={toggleMute}>
                    {isMuted ? <VolumeX size={15} /> : <Volume2 size={15} />}
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Storysection;